export const GET_JOBCATEGORIES = "GET_JOBCATEGORIES";
export const GET_JOBCATEGORIES_SUCCESS = "GET_JOBCATEGORIES_SUCCESS";
export const GET_JOBCATEGORIES_FAIL = "GET_JOBCATEGORIES_FAIL";

export const GET_JOBCATEGORY_DETAILS = "GET_JOBCATEGORY_DETAILS";
export const GET_JOBCATEGORY_DETAILS_SUCCESS = "GET_JOBCATEGORY_DETAILS_SUCCESS";
export const GET_JOBCATEGORY_DETAILS_FAIL = "GET_JOBCATEGORY_DETAILS_FAIL";

export const JOBCATEGORY_UPDATE = "JOBCATEGORY_UPDATE";
export const JOBCATEGORY_UPDATE_SUCCESS = "JOBCATEGORY_UPDATE_SUCCESS";
export const JOBCATEGORY_UPDATE_FAIL = "JOBCATEGORY_UPDATE_FAIL";

export const JOBCATEGORY_CREATE = "JOBCATEGORY_CREATE";
export const JOBCATEGORY_CREATE_SUCCESS = "JOBCATEGORY_CREATE_SUCCESS";
export const JOBCATEGORY_CREATE_FAIL = "JOBCATEGORY_CREATE_FAIL";

export const JOBCATEGORY_DELETE = "JOBCATEGORY_DELETE";
export const JOBCATEGORY_DELETE_SUCCESS = "JOBCATEGORY_DELETE_SUCCESS";
export const JOBCATEGORY_DELETE_FAIL = "JOBCATEGORY_DELETE_FAIL";

export const RESET = "RESET";

export const GET_LOOKUP_JOBCATEGORIES = "GET_LOOKUP_JOBCATEGORIES";
export const GET_LOOKUP_JOBCATEGORIES_SUCCESS = "GET_LOOKUP_JOBCATEGORIES_SUCCESS";
export const GET_LOOKUP_JOBCATEGORIES_FAIL = "GET_LOOKUP_JOBCATEGORIES_FAIL";
